'use strict';

export default {
	isLoggedIn: (state, _, rootState) => !!state.tokens.access && rootState.ethers.connected,
};
